import {IAirBridge} from '../services/IAirBridge';
import {IPostAction} from './IPostAction';

export class NativePayAction implements IPostAction {
    constructor(private airBridge: IAirBridge) {
    }
    public execute({nativePayInfo}: Record<string, any>): void {
        if (!nativePayInfo) {
            throw new Error('No native pay info');
        }
        this.airBridge.evoke(`nativePayment|${JSON.stringify(nativePayInfo)}`);
    }
}


